import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <section id="footer">
                <ul className="icons">
                    <li><a className="icon alt fa-linkedin a-style" href="https://www.linkedin.com/in/kritapas-nimtrakul-ba522165/"> LinkedIn</a></li>
                    <li><a className="icon alt fa-github a-style" href="https://github.com/kxn9945"> Github</a></li>
                    <li><a className="icon alt fa-twitter a-style" href="https://twitter.com/JaeNimtrakul"> Twitter</a></li>
                </ul>
                <ul>

                  <a className='btn a-style' href="https://icons8.com/icon/92027/labyrinth">Labyrinth icon by Icons8</a>
                </ul>
                <ul className="copyright">
                <p className="copyright">© 2019 Kritapas Nimtrakul.</p>
                </ul>
            </section>
        )
    }              }

export default Footer
